module.exports = __webpack_public_path__ + "img/Avatar.c85f6184.svg";